import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'ru', label: 'RU' },
  { code: 'kz', label: 'KZ' },
] as const;

export function LanguageSelector() {
  const { i18n } = useTranslation();

  const handleChange = (code: string) => {
    i18n.changeLanguage(code);
    localStorage.setItem('arna-lang', code);
  };

  return (
    <div className="flex items-center gap-1">
      {LANGUAGES.map(({ code, label }) => (
        <Button
          key={code}
          variant={i18n.language === code ? 'default' : 'ghost'}
          size="sm"
          onClick={() => handleChange(code)}
          className="h-7 px-2 text-xs"
        >
          {label}
        </Button>
      ))}
    </div>
  );
}
